export const GROUP_NAME = 'tabs'

export enum Variants {
  Plain = 'plain',
  Transparent = 'transparent',
}

export const DEFAULT_VARIANT = Variants.Plain

export enum Orientations {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export const DEFAULT_ORIENTATION = Orientations.Horizontal

export enum Positions {
  End = 'end',
  Start = 'start',
}

export const DEFAULT_POSITION = Positions.Start

export enum Sizes {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
}

export const DEFAULT_SIZE = Sizes.Small
